var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 34,
    viewBox: "0 0 129 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(-30 -20)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Web_Builder",
    "data-name": "Web Builder",
    transform: "translate(67 50)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "SegoeUI, Segoe UI",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Builder")), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(30 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M225.363,201.726l-4.588,6.533-4.935,7.027-.076-.131L208.7,203.028h-2.325v11.577h-7.93V181.842h13.825c.139,0,.278,0,.416.007,6.1.2,10.973,4.786,10.973,10.413a10.42,10.42,0,0,1-6.676,9.488l3.715,6.378,9.533-13.576.107.107Z",
    transform: "translate(-198.446 -181.842)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.23a5aea3c40165c842c87bf18cdc2ec6.svg";
export { ForwardRef as ReactComponent };